export const uniqueList = (arr: string[]) => Array.from(new Set(arr));
